import { Component, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBaseReactComponent } from '../input-base-react/input-base-react.component';
import { KeyValueModel } from 'app/shared/models/KeyValueModel';
import { DataModel } from 'app/shared/models/DataModel';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'app-input-select-react',
    templateUrl: './input-select-react.component.html',
    styleUrls: ['./input-select-react.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputSelectReactComponent),
            multi: true
        }
    ]
})

export class InputSelectReactComponent extends InputBaseReactComponent implements ControlValueAccessor, OnInit, OnChanges {

    // atributo utilizado para efetuar preenchimento de itens
    @Input() cols = 0;
    @Input() items: Array<DataModel> = [];
    @Input() keyItems: Array<KeyValueModel> = [];
    @Input() isNumber = false;
    @Input() showSelectAll = true;
    @Input() valueIsArrayString = false;
    @Output() checkEmitter: EventEmitter<string> = new EventEmitter<string>();
    @Output() uncheckEmitter: EventEmitter<string> = new EventEmitter<string>();


    public selectedValues = new Array<any>();

    constructor() {
        super();
    }

    ngOnInit(): void {
        super.ngOnInit();

        if (this.control) {
            if (this.control.value) {
                this.value = this.control.value;
                // this.valorChange.emit(this.control.value);

                this.selectedValues = this.control.value as Array<any>;
            }
        }
        this.setAndUpdateValidators();

    }

    ngOnChanges(): void {
        super.ngOnChanges();
        this.setAndUpdateValidators();
    }

    public existeItemSelecionado(id: any) {

        if (this.valueIsArrayString) {
            return this.selectedValues.find(m => m === id) !== undefined;
        } else {
            return this.selectedValues.find(m => m.id === id) !== undefined;
        }
    }

    public mudarValor(event: any, valor: any, text: string, compl: string) {
        let change = false;

        if (this.value) {
            this.selectedValues = this.value as Array<DataModel>;
        }

        if (event.srcElement.checked) {
            let exists = false;

            if (this.valueIsArrayString) {
                exists = this.selectedValues.find(m => m === valor) != null;
            } else {
                exists = this.selectedValues.find(m => m.id === valor) != null;
            }

            if (!exists) {
                if (this.valueIsArrayString) {
                    this.selectedValues.push(valor);
                } else {
                    this.selectedValues.push(new DataModel(text, valor, compl));
                }
                change = true;
                this.checkEmitter.emit(valor);
            }
        } else {
            let index = -1;

            if (this.valueIsArrayString) {
                index = this.selectedValues.findIndex(m => m === valor);
            } else {
                index = this.selectedValues.findIndex(m => m.id === valor);
            }

            this.selectedValues.splice(index, 1);
            change = true;
            this.uncheckEmitter.emit(valor);
        }

        if (change) {
            this.value = this.selectedValues;
            if (this.control) {
                if (this.form.get(this.name) !== null) {
                    this.form.get(this.name).setValue(this.selectedValues);
                }
            }
        }
    }

    public getComboItemText(): string {
        if (this.control) {
            if ((this.items) && (this.items.length > 0)) {
                const item: DataModel = this.items.find(m => m.id === this.value);

                return (item ? item.nome : '');
            } else
                if ((this.keyItems) && (this.keyItems.length > 0)) {
                    const item: KeyValueModel = this.keyItems.find(m => m.key === this.value);

                    return (item ? item.value : '');
                } else {
                    return '';
                }
        } else {
            return '';
        }
    }

    public validarObrigatorio(): boolean {
        if (!this.value && this.required) {
            return true;
        } else
            if (this.value) {
                if (this.value.length === 0 && this.required) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
    }

    public selecionarTodos(event: any) {
        if (event.srcElement.checked) {

            if (this.valueIsArrayString) {
                this.selectedValues = new Array<string>();
            } else {
                this.selectedValues = new Array<DataModel>();
            }
            if (this.items != null) {
                if (this.items.length > 0) {
                    for (const item of this.items) {
                        if (this.valueIsArrayString) {
                            this.selectedValues.push(item.id);
                        } else {
                            this.selectedValues.push(item);
                        }
                        this.mudarValor(event, item.id, item.nome, item.complementar);
                        // this.checkEmitter.emit(item.id);
                    }

                }
            } else {
                if (this.keyItems != null) {
                    if (this.keyItems.length > 0) {
                        for (const item of this.keyItems) {
                            if (this.valueIsArrayString) {
                                this.selectedValues.push(item.key);
                            } else {
                                this.selectedValues.push(item);
                            }
                            this.mudarValor(event, item.key, item.value, '');
                            // this.checkEmitter.emit(item.key);
                        }
                    }
                }
            }
        } else {
            if (this.valueIsArrayString) {
                this.selectedValues = new Array<string>();
            } else {
                this.selectedValues = new Array<DataModel>();
            }
            // this.mudarValor(event, item.id, item.nome);
            // this.uncheckEmitter.emit(null);
        }

        this.value = this.selectedValues;
        if (this.control) {
            if (this.form.get(this.name) !== null) {
                this.form.get(this.name).setValue(this.selectedValues);
            }
        }

        if (event.srcElement.checked) {
            this.checkEmitter.emit('allChecked')
        } else {
            this.uncheckEmitter.emit('');
        }


    }
}
